import {
    useEffect,
    useState,
} from "react";

import DataTable from "components/table/DataTable";

import {
    getTaDaClaims,
    cancelTaDaClaim,
    submitTaDaClaim,
    approveTaDaClaim,
    rejectTaDaClaim,
    markTaDaClaimPaid,
} from "services/api/taDaApi";

import {
    showSuccess,
    showError,
} from "utils/toast";

import {
    taDaColumns,
} from "./columns";

import TaDaClaimModal from "./TaDaClaimModal";


export default function TaDaClaims() {

    const [
        claims,
        setClaims,
    ] = useState([]);


    const [
        loading,
        setLoading,
    ] = useState(false);


    const [
        page,
        setPage,
    ] = useState(1);


    const [
        openModal,
        setOpenModal,
    ] = useState(false);


    const [
        selectedItem,
        setSelectedItem,
    ] = useState(null);



    /*
    |--------------------------------------------------------------------------
    | LOAD
    |--------------------------------------------------------------------------
    */

    const loadData =
        async () => {

            try {

                setLoading(true);


                const response =
                    await getTaDaClaims(
                        page,
                        10
                    );


                console.log(
                    "TA/DA RESPONSE",
                    response
                );


                setClaims(
                    response?.data?.claims ||
                    []
                );

            }
            catch (error) {

                console.error(
                    error
                );


                showError(
                    error?.response?.data?.message ||
                    "Unable to load TA/DA claims."
                );

            }
            finally {

                setLoading(false);

            }

        };



    useEffect(() => {

        loadData();

    }, [
        page,
    ]);



    /*
    |--------------------------------------------------------------------------
    | ADD
    |--------------------------------------------------------------------------
    */

    const handleAdd = () => {

        setSelectedItem(null);

        setOpenModal(true);

    };



    /*
    |--------------------------------------------------------------------------
    | EDIT
    |--------------------------------------------------------------------------
    */

    const handleEdit = (
        claim
    ) => {

        setSelectedItem(
            claim
        );

        setOpenModal(true);

    };



    /*
    |--------------------------------------------------------------------------
    | CANCEL
    |--------------------------------------------------------------------------
    */

    const handleCancel =
        async (id) => {

            if (
                !window.confirm(
                    "Cancel this TA/DA claim?"
                )
            ) {

                return;

            }


            try {

                await cancelTaDaClaim(
                    id
                );


                showSuccess(
                    "TA/DA claim cancelled successfully."
                );


                await loadData();

            }
            catch (error) {

                showError(
                    error?.response?.data?.message ||
                    "Unable to cancel claim."
                );

            }

        };



    /*
    |--------------------------------------------------------------------------
    | SUBMIT
    |--------------------------------------------------------------------------
    */

    const handleSubmit =
        async (id) => {

            if (
                !window.confirm(
                    "Submit this TA/DA claim for approval?"
                )
            ) {

                return;

            }


            try {

                await submitTaDaClaim(
                    id
                );


                showSuccess(
                    "TA/DA claim submitted successfully."
                );


                await loadData();

            }
            catch (error) {

                showError(
                    error?.response?.data?.message ||
                    "Unable to submit claim."
                );

            }

        };



    /*
    |--------------------------------------------------------------------------
    | APPROVE
    |--------------------------------------------------------------------------
    */

    const handleApprove =
        async (id) => {

            const amount =
                window.prompt(
                    "Approved amount"
                );


            if (
                amount === null
            ) {

                return;

            }


            if (
                !amount.trim()
            ) {

                showError(
                    "Approved amount is required."
                );

                return;

            }


            try {

                await approveTaDaClaim(
                    id,
                    {
                        approvedAmount:
                            amount.trim(),

                        remarks:
                            "Approved after verification.",
                    }
                );


                showSuccess(
                    "TA/DA claim approved successfully."
                );


                await loadData();

            }
            catch (error) {

                showError(
                    error?.response?.data?.message ||
                    "Unable to approve claim."
                );

            }

        };



    /*
    |--------------------------------------------------------------------------
    | REJECT
    |--------------------------------------------------------------------------
    */

    const handleReject =
        async (id) => {

            const reason =
                window.prompt(
                    "Rejection reason"
                );


            if (
                !reason ||
                !reason.trim()
            ) {

                return;

            }


            try {

                await rejectTaDaClaim(
                    id,
                    reason.trim()
                );


                showSuccess(
                    "TA/DA claim rejected successfully."
                );


                await loadData();

            }
            catch (error) {

                showError(
                    error?.response?.data?.message ||
                    "Unable to reject claim."
                );

            }

        };



    /*
    |--------------------------------------------------------------------------
    | MARK PAID
    |--------------------------------------------------------------------------
    */

    const handleMarkPaid =
        async (id) => {

            const paymentRefNo =
                window.prompt(
                    "Payment reference number (optional)"
                );


            try {

                await markTaDaClaimPaid(
                    id,
                    {
                        paymentRefNo:
                            paymentRefNo?.trim() ||
                            undefined,

                        remarks:
                            "TA/DA claim paid.",
                    }
                );


                showSuccess(
                    "TA/DA claim marked as paid."
                );


                await loadData();

            }
            catch (error) {

                showError(
                    error?.response?.data?.message ||
                    "Unable to mark claim as paid."
                );

            }

        };



    return (

        <div className="mt-5">

            <DataTable

                title="TA/DA Claims"

                columns={
                    taDaColumns({
                        onEdit:
                            handleEdit,

                        onCancel:
                            handleCancel,

                        onSubmit:
                            handleSubmit,

                        onApprove:
                            handleApprove,

                        onReject:
                            handleReject,

                        onMarkPaid:
                            handleMarkPaid,
                    })
                }

                data={
                    claims
                }

                loading={
                    loading
                }

                onAdd={
                    handleAdd
                }

                addButtonText="Create TA/DA Claim"

            />


            <TaDaClaimModal

                open={
                    openModal
                }

                onClose={() =>
                    setOpenModal(false)
                }

                reload={
                    loadData
                }

                item={
                    selectedItem
                }

            />

        </div>

    );

}